import React from 'react';
import PropTypes from 'prop-types';

export const GeoIPContext = React.createContext();

const GeoIPProvider = ({ children }) => {
    const geoIpCountryItem = document.getElementById('geoip-country');
    const geoipLocal = geoIpCountryItem?.dataset.geoIpCountry || null;

    return <GeoIPContext.Provider value={{ geoipLocal }}>{children}</GeoIPContext.Provider>;
};

GeoIPProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const withGeoIP = (Component) => {
    class GeoIPConsumer extends React.PureComponent {
        render() {
            return (
                <GeoIPContext.Consumer>
                    {(context) => <Component {...this.props} {...context} />}
                </GeoIPContext.Consumer>
            );
        }
    }

    return GeoIPConsumer;
};

export default GeoIPProvider;
